import { BASE_API_URL } from '@env';
import { useQuery } from 'react-query';
import { useUserStore } from '~providers/userStore/zustand';
import { USER_EVENT_STATUS } from '~types/api/user';

export interface StatusResponseType {
  event_id: number
  user_id: string
  user_name: string
  user_photo: string
  created_at: string
  payment_detail: PaymentDetail
}

export interface PaymentDetail {
  id: string
  amount: number
  currency: string
  status: string
  created_at: string
}


export function useGetEventPayperMatchStatus({ event_id }: { event_id: number; }) {
  return useQuery<StatusResponseType | undefined, Error>(['eventUserStatusPaypermatch', event_id], async () => {

    if (!event_id) {
      return undefined;
    }
    const token = useUserStore.getState().token;
    const response = await fetch(`${BASE_API_URL}events/${event_id}/match/payment-details`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    if (!response.ok) {
      console.log(await response.json(), 'datadatadatadatadata. err');
      return;
    }

    const data = await response.json();
    console.log(data, 'datadatadatadatadata');


    return data as StatusResponseType;
  });
}
